// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"9ab8c9ec","150":"4293ecf1","382":"656a3eac","453":"51a16142","659":"3810c7fd","681":"d0d8a130","750":"4ea0abc1","938":"bd78c3ed"}[chunkId] + ".chunk.js";
};